<template>
  <div id="google-trending-page">
    <!-- page header component -->
    <page-header-component icon="bi bi-google" title="Google Trending Topik" :hide-filter="true" class="px-gap" />
    <!-- page component -->
    <transition name="block">
      <floating-loader-component v-if="is_loading" />
      <div v-else>
        <div v-if="google_trends">
          <div v-for="(trend, index) in google_trends" :key="index" class="px-gap">
            <h4>{{ dateFormatterID(trend.tgl_berita) }}</h4>
            <div class="card card-default shade">
              <div v-for="(item, index) in trend.data" :key="item.title">
                <div class="card-body mb-0 hover clickable" :class="index_show == index + trend.tgl_berita ? 'shadow ' : ''
                  ">
                  <div class="row" @click="showDetail(index + trend.tgl_berita)">
                    <div class="col-1 d-flex">
                      <h3 class="text-muted ml-4">
                        {{ index + 1 }}
                      </h3>
                    </div>
                    <div class="col-8">
                      <h3>{{ item.title }}</h3>
                      <h4 v-if="index_show == index + trend.tgl_berita">
                        {{ numberFormatter(item["ht:approx_traffic"]) }}
                        penelusuran
                      </h4>
                      <h6 v-else class="d-flex align-items-center">
                        <a :href="subItemUrl(item['ht:news_item'])" target="_blank" class="text-blue clickable hoverable">
                          {{ subItemTitle(item["ht:news_item"]) }}
                        </a>
                        <span class="ml-3 text-muted">
                          {{ item["ht:picture_source"] }}
                          <i class="bi bi-circle-fill" style="font-size: 5px"></i>
                          {{ timeFormatterID(item.pubDate) }}
                        </span>
                      </h6>
                    </div>
                    <div class="col-1">
                      <div v-if="index_show != index + trend.tgl_berita">
                        <h4>
                          {{ numberFormatter(item["ht:approx_traffic"]) }}
                        </h4>
                        <small class="text-muted">penelusuran</small>
                      </div>
                    </div>
                    <div class="col-1 d-flex">
                      <a :href="subItemUrl(item['ht:news_item'])" target="_blank"
                        class="text-blue clickable hoverable mx-auto">
                        <img v-if="index_show != index + trend.tgl_berita" style="width: 100%; z-index: 99 !important"
                          :src="item['ht:picture']" class="rounded" />
                        <div v-if="index_show != index + trend.tgl_berita"
                          style="margin-top: -20px; z-index: 999 !important" class="text-white d-flex w-100">
                          <div class="mx-auto text-center" style="font-size: 12px">
                            {{ item["ht:picture_source"] }}
                          </div>
                        </div>
                      </a>
                    </div>
                    <div class="col-1 d-flex">
                      <h2 class="mr-3 ml-auto my-auto">
                        <i class="bi bi-caret-up-fill" v-if="index_show == index + trend.tgl_berita"></i>
                        <i class="bi bi-caret-down-fill" v-else></i>
                      </h2>
                    </div>
                  </div>
                  <transition name="fade">
                    <div v-if="index_show == index + trend.tgl_berita" class="collapse-content mx-4 py-3">
                      <div v-if="item.description" class="mb-3">
                        <hr />
                        <h5 class="text-muted">Kueri Terkait</h5>
                        <div class="d-flex flex-wrap">
                          <div class="border rounded p-1 mr-1 mb-1" v-for="desc in cekDescription(item.description)"
                            :key="desc">
                            <span class="h6">{{ desc }}</span>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <h5 class="text-muted">Berita Terkait</h5>
                      <div v-if="Array.isArray(item['ht:news_item'])" class="scroll-container">
                        <button v-if="item['ht:news_item'].length > 2" class="btn btn-white" style="
                            position: absolute;
                            left: 35px;
                            margin-top: 35px;
                            border-radius: 50%;
                            z-index: 999;
                          " @click="scrollLeft">
                          <i class="bi bi-chevron-left" style="margin-right: 3px; margin-top: 3px"></i>
                        </button>
                        <button v-if="item['ht:news_item'].length > 2" class="btn btn-white" style="
                            position: absolute;
                            right: 35px;
                            margin-top: 35px;
                            border-radius: 50%;
                            z-index: 999;
                          " @click="scrollRight">
                          <i class="bi bi-chevron-right" style="margin-left: 3px; margin-top: 3px"></i>
                        </button>
                        <div class="scroll-content">
                          <div class="scroll-item" v-for="(sub, idx) in item['ht:news_item']"
                            :key="sub['ht:news_item_title']">
                            <a :href="sub['ht:news_item_url']" target="_blank" class="hoverable clickable text-dark">
                              <div class="d-flex">
                                <div class="mr-3">
                                  <div v-if="idx == 0">
                                    <img :src="item['ht:picture']" class="img-sub" />
                                  </div>
                                  <div v-else>
                                    <img src="../../../public/assets/img/web/globe.png" width="110" class="img-sub"
                                      style="border-radius: 20px" />
                                  </div>
                                </div>
                                <div class="pr-3 py-3">
                                  <p class="text-justify h6">
                                    {{ sub["ht:news_item_title"] }}
                                  </p>
                                  <p class="h6 text-muted">
                                    {{ sub["ht:news_item_source"] }}
                                  </p>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <div class="w-50 scroll-item">
                          <a :href="item['ht:news_item']['ht:news_item_url']" target="_blank"
                            class="hoverable clickable text-dark">
                            <div class="d-flex">
                              <div class="mr-3">
                                <img :src="item['ht:picture']" class="img-sub" />
                              </div>
                              <div class="pr-3 py-3">
                                <p class="text-justify h6">
                                  {{
                                    item["ht:news_item"]["ht:news_item_title"]
                                  }}
                                </p>
                                <p class="h6 text-muted">
                                  {{
                                    item["ht:news_item"]["ht:news_item_source"]
                                  }}
                                </p>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </transition>
                </div>
                <hr v-if="index_show != index + trend.tgl_berita" />
              </div>
            </div>
          </div>
        </div>
        <div v-else class="col-md-12 col-sm-12 col-lg-12 px-2">
          <div class="bg-white px-2 py-1 shade">
            <div class="alert alert-danger mt-1 mb-1" id="errorApiEl" role="alert" align="center">
              <strong>Mohon maaf, data tidak tersedia! </strong> <br />
              Silahkan lakukan pencarian dengan parameter lain
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import page_header from "@/views/components/page_header.vue";
import floating_loader from "@/views/components/floating_loader.vue";
import moment from "moment";

export default {
  name: "GoogleTrending",
  title: "Google Tren | Sibernetik",
  components: {
    "page-header-component": page_header,
    "floating-loader-component": floating_loader,
  },
  data() {
    return {
      is_trending: this.$store.getters.user.project.project_detail
        .twitter_trending
        ? true
        : false,
      mounted: false,
      is_loading: false,
      tour_steps: [],
      index_show: -1,
      temp_idx: -1,
      google_trends: null,
    };
  },
  methods: {
    getData: function () {
      this.is_loading = true;
      let api = "https://be.kurasi.media/google-trends/get-google-trends";
      this.$http
        .post(api)
        .then((response) => {
          if (response.status == 200) {
            this.google_trends = response.data;
          } else {
            this.google_trends = null;
          }
        })
        .catch(() => {
          this.google_trends = null;
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    showDetail: function (idx) {
      if (idx != this.temp_idx) {
        this.index_show = idx;
      } else {
        this.index_show = -1;
      }
      this.temp_idx = this.index_show;
    },
    scrollLeft: function () {
      const container = document.querySelector(".scroll-container");
      container.scrollBy({ left: -450, behavior: "smooth" });
    },
    scrollRight: function () {
      const container = document.querySelector(".scroll-container");
      container.scrollBy({ left: 450, behavior: "smooth" });
    },
    dateFormatterID: function (date) {
      moment.locale("id");
      return moment(date).format("dddd, Do MMMM YYYY");
    },
    timeFormatterID: function (date) {
      moment.locale("id");
      return moment(date).startOf("hour").fromNow();
    },
    cekDescription: function (desc) {
      const temp = desc.split(",");
      return temp;
    },
    numberFormatter: function (val) {
      const temp = val.split(",");
      if (temp.length == 1) {
        return temp[0] + "+";
      } else if (temp.length == 2) {
        return temp[0] + " rb+";
      } else if (temp.length == 3) {
        return temp[0] + " jt+";
      } else if (temp.length == 4) {
        return temp[0] + " my+";
      } else if (temp.length == 5) {
        return temp[0] + " tr+";
      }
    },
    subItemTitle: function (item) {
      const temp = item[0];
      if (temp) {
        return temp["ht:news_item_title"];
      }
      return item["ht:news_item_title"];
    },
    subItemUrl: function (item) {
      const temp = item[0];
      if (temp) {
        return temp["ht:news_item_url"];
      }
      return item["ht:news_item_url"];
    },
  },
  created: function () {
    this.getData();
  },
  mounted: function () {
    this.mounted = true;
  },
};
</script>
<style>
.detail {
  background-color: aqua !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  transition: max-height 0 ease-in-out, opacity 0 ease-in-out;
  opacity: 0;
}
</style>
<style scoped>
hr {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

.hover:hover {
  background-color: rgba(194, 189, 189, 0.103);
}

.scroll-container {
  width: 100%;
  overflow-x: auto;
}

.scroll-content {
  white-space: nowrap;
}

.scroll-item {
  display: inline-block;
  width: 49.5%;
  height: 100px;
  background-color: #f0f0f0;
  margin-right: 15px;
  border-radius: 20px;
}

.scroll-container::-webkit-scrollbar {
  display: none;
}

.img-sub {
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
}
</style>
